import React, { useMemo, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// Optional: register font sizes (style-based px sizes)
const Size = ReactQuill.Quill.import("attributors/style/size");
Size.whitelist = ["12px", "14px", "16px", "18px", "24px", "32px"];
ReactQuill.Quill.register(Size, true);

export default function LegalRichEditor({ value, onChange, minHeight = 320 }) {
  const quillRef = useRef(null);

  // ✅ Safe id (only letters/numbers/dash). Stable for this component instance.
  const toolbarIdRef = useRef(
    `ql-toolbar-${Math.random().toString(36).slice(2, 10)}`
  );
  const toolbarId = toolbarIdRef.current;

  const modules = useMemo(
    () => ({
      toolbar: {
        // ✅ Quill will querySelector this safely
        container: `#${toolbarId}`,

        // Optional: if you ever need handlers you can add them here
        // handlers: {}
      },
      clipboard: { matchVisual: true },
    }),
    [toolbarId]
  );

  const formats = useMemo(
    () => [
      "header",
      "size",
      "bold",
      "italic",
      "underline",
      "strike",
      "align",
      "list",
      "indent",
      "blockquote",
      "link",
    ],
    []
  );

  return (
    <div style={{ border: "1px solid #d9d9d9", borderRadius: 10, overflow: "hidden", background: "#fff" }}>
      {/* ✅ Toolbar UI */}
      <div id={toolbarId} className="ql-toolbar ql-snow" style={{ border: 0, borderBottom: "1px solid #d9d9d9" }}>
        <span className="ql-formats">
          <select className="ql-header" defaultValue="">
            <option value="">Normal</option>
            <option value="1">Heading 1</option>
            <option value="2">Heading 2</option>
            <option value="3">Heading 3</option>
          </select>

          <select className="ql-size" defaultValue="14px">
            {Size.whitelist.map((s) => (
              <option key={s} value={s}>
                {s.replace("px", "")}
              </option>
            ))}
          </select>
        </span>

        <span className="ql-formats">
          <button className="ql-bold" />
          <button className="ql-italic" />
          <button className="ql-underline" />
          <button className="ql-strike" />
        </span>

        <span className="ql-formats">
          <button className="ql-list" value="ordered" />
          <button className="ql-list" value="bullet" />
          <button className="ql-indent" value="-1" />
          <button className="ql-indent" value="+1" />
        </span>

        <span className="ql-formats">
          <select className="ql-align" defaultValue="">
            <option value="">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
            <option value="justify">Justify</option>
          </select>
        </span>

        <span className="ql-formats">
          <button className="ql-blockquote" />
          <button className="ql-link" />
          <button className="ql-clean" />
        </span>
      </div>

      {/* Editor */}
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={modules}
        formats={formats}
        style={{ minHeight }}
      />
    </div>
  );
}
